import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { AspectRatio, Block, Close, CloudUpload, Delete, Filter } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import RoomIcon from '@material-ui/icons/Room';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { getInfosDashboard } from '@webapps/business';
import {
  getInfosAccountRestricted,
  checkIfPostuleOffer,
  checkIfSavedOffer,
  connectABusinessPartner,
  postuleOffer,
  savedOffer,
  unSavedOffer,
} from '@webapps/business';
import { useQuery, useRouter } from '@webapps/reactjs-tech-components';
import {
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import Partenaire from 'components/Icons/Partenaire';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import theme from '../../theme';
import { useCv } from 'pages/MyMap/Store/CvProvider';
import { Checkbox, DialogContent, DialogTitle, FormControlLabel, Typography } from '@material-ui/core';
import NewModal from 'components/NewModal';

const InfoName = ({
  partnersAccepted,
  partnersRequested,
  partnersReceived,
  handleRefetch,
  accountInfos,
  info = {},
  closeModal,
  userInfo
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);


  const windowWidth = window.innerWidth;

  const {
    images: { Candidate },
  } = theme;


  const { addToast } = useToast();
  const [openNeedCV, setOpenNeedCV] = useState(false);

  const { state, dispatch } = useCv();
  const [localCV, setLocalCV] = useState(state?.cv);
  const [fileName, setFileName] = useState(state?.cvName);
  const [isSavingDefault, setIsSavingDefault] = useState(state?.isCvSaved);
  const [tempCv, setTempCv] = useState(null); // CV temporaire avant validation
  const [useAsDefault, setUseAsDefault] = useState(false);
  const [deleteCvTemp, setDeleteCvTemp] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [cvNameGlobal, setCvNameGlobal] = useState(state?.cvName);
  const [cvGlobal, setCvGlobal] = useState(state?.cv);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // Supprime le préfixe data
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3 Mo en octets

    if (file.type !== "application/pdf") {
      addToast({
        status: 'error',
        message: "Veuillez sélectionner un fichier PDF !",
      });
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      addToast({
        status: 'error',
        message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
      });
      return;
    }

    try {
      setFileName(file.name);
      const base64String = await convertToBase64(file);
      setLocalCV(base64String);
      addToast({
        status: 'success',
        message: "CV chargé avec succès !",
      });
    } catch (error) {
      console.error("Erreur conversion Base64:", error);
      addToast({
        status: 'error',
        message: "Erreur lors du chargement du fichier !",
      });
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3 Mo en octets

    if (!file || file.type !== "application/pdf") {
      addToast({
        status: 'error',
        message: "Veuillez sélectionner un fichier PDF !",
      });
      setTempCv(null);
      event.target.value = null;
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      addToast({
        status: 'error',
        message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
      });
      setTempCv(null);
      event.target.value = null;
      return;
    }

    try {
      const base64String = await convertToBase64(file);
      setTempCv({ content: base64String, name: file.name });
      addToast({
        status: 'success',
        message: "CV chargé avec succès !",
      });
    } catch (error) {
      console.error("Erreur lors du chargement du fichier:", error);
      addToast({
        status: 'error',
        message: "Erreur lors du chargement du fichier !",
      });
    }
  };

  console.log("NX_LBA_API_TOKEN : ", process.env.NX_LBA_API_TOKEN);

  const handleDeleteCv = () => {

    setTempCv(null);
    setDeleteCvTemp(true);
  };

  const closeNeedCV = () => {

    setDeleteCvTemp(false);
    setTempCv(null);
    setOpenNeedCV(false);
  };

  const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3 Mo en octets

  const checkFileSize = (base64String) => {
    // Calculer la taille approximative du fichier base64
    const base64Length = base64String.length;
    const fileSizeInBytes = (base64Length * 3) / 4; // Conversion approximative base64 vers taille réelle
    return fileSizeInBytes <= MAX_FILE_SIZE;
  };

  const handleSubmit = () => {
    if (tempCv) {
      if (!checkFileSize(tempCv.content)) {
        addToast({
          status: 'error',
          message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
        });
        return;
      }

      if (useAsDefault) {
        dispatch({ type: "SET_CV", payload: tempCv });
        setCvNameGlobal(tempCv.name);
        setCvGlobal(tempCv.content);
      }

      postOfferWithLBA({ content: tempCv.content, name: tempCv.name });
    } else {
      if (state.cv) {
        if (!checkFileSize(state.cv)) {
          addToast({
            status: 'error',
            message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
          });
          return;
        }
        postOfferWithLBA({ content: state.cv, name: state.cvName });
      } else {
        addToast({
          status: 'error',
          message: "Aucun fichier sélectionné !",
        });
        return;
      }
    }
    closeNeedCV();
  };

  const postOfferWithLBA = async (cv) => {
    try {
      if (!checkFileSize(cv.content)) {
        addToast({
          status: 'error',
          message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
        });
        return;
      }

      const postuleOfferAPILBA = await fetch(`${process.env.NX_REST_API}/jobs/module/offers/lba/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          applicant_first_name: userInfo?.firstname,
          applicant_last_name: userInfo?.lastname,
          applicant_email: userInfo?.email,
          applicant_phone: userInfo?.phone,
          applicant_attachment_name: cv.name,
          applicant_attachment_content: `data:application/pdf;base64,${cv.content}`,
          recipient_id: info?.idLaBonneAlternance,
          applicant_message: null
        }),
      });

      const postuleOfferAPILBAJson = await postuleOfferAPILBA.json();

      if (postuleOfferAPILBAJson.statusCode == 401) {
        addToast({
          status: 'error',
          message: "Erreur lors de l'envoi du CV",
        });
        return;
      }

      await mutatePostuleOffer({
        data: {
          applicant: {
            id: idUser,
          },
          offer: {
            id: info?.id,
          },
          fromLaBonneAlternance: true
        },
      });
    } catch (error) {
      console.error("error postuleOfferAPILBA : ", error);
      addToast({
        status: 'error',
        message: "Erreur lors de l'envoi du CV",
      });
    }
  };

  const {
    isLoading: isLoadingSavedOffer,
    isSuccess: isSuccessSave,
    mutateAsync: mutateSavedOffer,
  } = useMutation(savedOffer);

  const {
    isLoading: isLoadingPostuleOffer,
    isSuccess: isSuccessPostule,
    mutateAsync: mutatePostuleOffer,
  } = useMutation(postuleOffer);

  const {
    isLoading: isLoadingUnSavedOffer,
    isSuccess: isSuccessUnSave,
    mutateAsync: mutateUnSavedOffer,
  } = useMutation(unSavedOffer);


  const { data: infoBusinessAccount = {} } = useQuery(getInfosAccountRestricted, {
    key: 'infoSchoolAccount' + info?.business?.id,
    variables: { id: info?.business?.id },
    enabled: !!info?.business?.id,
  });

  useEffect(() => {
    if (isSuccessPostule) {
      addToast({
        status: 'success',
        message: "Vous avez postulé à l'offre",
      });
    }
    refetchPostule();
  }, [isSuccessPostule]);

  const postOffer = async () => {

    if (info?.idLaBonneAlternance) {

      setOpenNeedCV(true);
      return;

    } else {
      await mutatePostuleOffer({
        data: {
          applicant: {
            id: idUser,
          },
          offer: {
            id: info?.id,
          },
          fromLaBonneAlternance: false
        },
      });
    }

  };

  const saveOffer = async () => {
    await mutateSavedOffer({
      data: {
        applicant: {
          id: idUser,
        },
        offer: {
          id: info?.id,
        },
      },
    });
  };

  const unSaveOffer = async () => {
    await mutateUnSavedOffer({
      idApplicant: idUser,
      idOffer: info?.id,
    });
  };

  const { profile } = useAuth();
  const { idUser } = useAuth();

  const { data: checkPostule = {}, refetch: refetchPostule } = useQuery(
    checkIfPostuleOffer,
    {
      key: ['checkPostuleOffer'] + idUser + info?.id,
      variables: { idApplicant: idUser, idOffer: info?.id },
    }
  );

  const { push } = useRouter();

  const handleOpenVitrine = (id) => {
    push(ROUTES_PATH.BUSINESS_VITRINE, { params: { id }, from: 'map' });
  };

  const { data: images = {} } = useQuery(getInfosDashboard, {
    key: ['imageProfile', info?.business?.id],
    variables: { id: info?.business?.id },
    enabled: info?.business ? true : false,
  });

  const { data: checkSave = {}, refetch } = useQuery(checkIfSavedOffer, {
    key: ['checkSavedOffer'] + idUser + info?.id,
    variables: { idApplicant: idUser, idOffer: info?.id },
  });

  useEffect(() => {
    if (isSuccessSave) {
      addToast({
        status: 'success',
        message: 'Offre sauvegardée',
      });
    }
    refetch();
  }, [isSuccessSave]);

  useEffect(() => {
    if (isSuccessUnSave) {
      addToast({
        status: 'success',
        message: 'Offre retiré des sauvegardes',
      });
    }
    refetch();
  }, [isSuccessUnSave]);


  const {
    error: isErrorConnect,
    isLoading: isLoadingConnect,
    isSuccess: isSuccessConnect,
    mutateAsync: mutateConnect,
  } = useMutation(connectABusinessPartner);

  const reqPartner = async () => {
    await mutateConnect({
      data: {
        schoolId: idUser,
        businessId: info?.business?.id,
      },
    });
  };

  useEffect(() => {
    if (isSuccessConnect) {
      addToast({
        status: 'success',
        message: 'Demande envoyée',
      });
      handleRefetch();
    }
    if (isErrorConnect) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la demande',
      });
    }
  }, [isSuccessConnect, isErrorConnect]);

  return (
    <div className={classes.container}>
      <div className={
        css({
          width: '100%',
          backgroundImage: `linear-gradient(rgba(5, 6, 50, 0.75), rgba(5, 6, 50, 0.75)), url(${images?.profile?.coverImageUrl || info?.businessLaBonneAlternance?.banner})`,
          backgroundSize: 'cover',
          backgroundBlendMode: 'darken',
          borderRadius: '10px 10px 0 0px',
          '@media only screen and (max-width:1023px)': {
            borderRadius: 0,
          },
        })
      }>
        <div
          className={cx(
            classes.divInfos,
            css({
              padding: '24px',
              top: 0,
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
              '@media only screen and (max-width:1023px)': {
                flexDirection: 'row',
                alignItems: 'flex-start',
                display: 'flex',
                padding: spacing(2),
              },
            })
          )}
        >
          <AvatarCompany
            width={windowWidth > 1600 ? 130 : 80}
            height={windowWidth > 1600 ? 130 : 80}
            idCompany={info?.business?.id || info?.businessExternal || info?.businessLaBonneAlternance}
            name={info?.business?.name || info?.businessExternal?.name || info?.businessLaBonneAlternance?.name}
          />
          <div className={classes.nameContainer}>
            <div className={cx(global.infoText, classes.name)}>
              <div style={{ marginRight: 5, fontWeight: 700 }} >{info?.business?.name?.toUpperCase() || info?.businessExternal?.name?.toUpperCase() || info?.businessLaBonneAlternance?.name?.toUpperCase()}</div>
              {info?.business?.name && (
                <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
              )}
            </div>
            <div className={cx(global.mainTitle, classes.titleJob)}>{info?.job?.label}</div>
            <div className={cx(global.infoText, classes.address)}>
              <RoomIcon className={cx(global.smallIcon, classes.imgAdress)} />
              <div>
                {info?.address?.city} {info?.address?.cityCode}{' '}
              </div>
            </div>
          </div>
        </div>
        <div
          className={cx(
            classes.btnsContainer,
            css({
              bottom: 0,
              padding: '0 24px 24px 24px',
              justifyContent: 'start',
              alignItems: 'center',
              display: ((profile !== "INDIVIDUAL" && (info?.businessExternal || info?.businessLaBonneAlternance)) || profile === "BUSINESS") ? 'none' : 'flex',
              '@media only screen and (max-width:1023px)': {
                width: '100%',
                display: 'none',
              },
            })
          )}
        >
          {profile === 'INDIVIDUAL' && (
            <div className={classes.btnaddfavoris}>
              {checkPostule ? (
                <Button
                  className={css({
                    width: '250px',
                  })}
                  disabled
                  variant="outlined"
                >
                  Déjà postulé
                </Button>
              ) : (
                <Button
                  className={css({
                    width: '250px',
                  })}
                  color="primary"
                  disabled={isLoadingPostuleOffer}
                  onClick={postOffer}
                  variant="contained"
                >
                  Postuler
                </Button>
              )}
            </div>
          )}
          {profile === 'SCHOOL' && !info?.businessExternal && !info?.businessLaBonneAlternance && (
            <div className={css({ marginRight: 16 })}>
              {partnersAccepted?.find(({ id }) => id === info?.business?.id) && (
                <Button
                  className={css({
                    marginRight: 16,
                    width: '100%',
                    '&:disabled': {
                      color: '#A6A6A6',
                      backgroundColor: '#E0E0E0',
                    },
                  })}
                  startIcon={<Partenaire />}
                  color="primary"
                  variant="contained"
                  disabled
                >
                  <FormattedMessage id="business.dashboard.dashboardBtns.partnerActive" />
                </Button>
              )}
              {accountInfos?.subscription &&
                accountInfos?.subscription.toLowerCase() == 'premium' &&
                infoBusinessAccount?.subscription &&
                infoBusinessAccount?.subscription.toLowerCase() == 'premium' &&
                !info?.idLaBonneAlternance &&
                !partnersAccepted?.find(({ id }) => id === info?.business?.id) &&
                !partnersRequested?.find(({ id }) => id === info?.business?.id) &&
                !partnersReceived?.find(({ id }) => id === info?.business?.id) && (
                  <Button
                    className={css({
                      marginRight: 16,
                      width: '100%',
                      '&:disabled': {
                        color: '#A6A6A6',
                        backgroundColor: '#E0E0E0',
                      },
                    })}
                    startIcon={<Partenaire />}
                    color="primary"
                    onClick={reqPartner}
                    variant="contained"
                  >
                    <FormattedMessage id="business.dashboard.dashboardBtns.partnerbtn" />
                  </Button>
                )}
              {(partnersRequested?.find(({ id }) => id === info?.business?.id) ||
                partnersReceived?.find(({ id }) => id === info?.business?.id)) ? (
                <Button
                  className={css({
                    marginRight: 16,
                    width: '100%',
                    '&:disabled': {
                      color: '#A6A6A6',
                      backgroundColor: '#E0E0E0',
                    },
                  })}
                  startIcon={<Partenaire />}
                  color="primary"
                  variant="contained"
                  disabled
                >
                  <FormattedMessage id="business.dashboard.dashboardBtns.partnerPending" />
                </Button>
              ) : null}
            </div>
          )}
          {profile === 'INDIVIDUAL' && !checkPostule && (
            <div className={classes.btnaddfavoris}>
              {checkSave ? (
                <Button
                  className={css({
                    marginRight: 16,
                    '&:hover': {
                      backgroundColor: '#F3F7FF',
                      color: '#5A6DA1',
                    },
                  })}
                  disabled={isLoadingUnSavedOffer}
                  onClick={unSaveOffer}
                  fullWidth
                  startIcon={<FavoriteIcon color="primary" />}
                  variant="outlined"
                >
                  <FormattedMessage id="AddedToFavorite" />
                </Button>
              ) : (
                <Button
                  className={css({
                    marginRight: 16,
                    '&:hover': {
                      backgroundColor: '#F3F7FF',
                      color: '#5A6DA1',
                    },
                  })}
                  disabled={isLoadingSavedOffer}
                  fullWidth
                  onClick={saveOffer}
                  startIcon={<FavoriteBorderIcon />}
                  variant="outlined"
                >
                  <FormattedMessage id="AddToFavorite" />
                </Button>
              )}
            </div>
          )}
          {(profile === 'BUSINESS' || info?.businessExternal) ? null : (
            info?.idLaBonneAlternance ? "" : (<Button
              className={cx(
                classes.btnVitrine,
                css({
                  marginRight: 16,
                  '&:hover': {
                    backgroundColor: '#F3F7FF',
                    color: '#5A6DA1',
                  },
                })
              )}
              onClick={() => handleOpenVitrine(info?.business?.id)}
              variant="outlined"
            >
              <VisibilityIcon style={{ marginRight: 5 }} /> Visualiser la
              vitrine
            </Button>)
          )}
        </div>
      </div>
      <div>
        <IconButton
          onClick={closeModal}
          className={css({
            zIndex: 2,
            backgroundColor: 'white',
            border: '1px solid #C0D9FF',
            height: '30px',
            width: '30px',
            position: 'absolute',
            top: 20,
            right: 20,
            '&:hover': {
              backgroundColor: 'white',
            },
            '@media only screen and (min-width:1024px)': {
              display: 'none', // Cache la croix pour les écrans larges
            },
            '@media only screen and (max-width:1023px)': {
              display: 'flex', // Affiche la croix pour les écrans étroits
              justifyContent: 'center',
              alignItems: 'center',
            },
          })}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <NewModal
        open={openNeedCV}
        onCancel={closeNeedCV}
        title='Envoyer votre CV'
        subtitle='Vous avez besoin de votre CV pour postuler à cette offre.'
        image={{
          src: Candidate,
          width: 100,

        }}
        actions={[
          {
            label: "Annuler",
            onClick: closeNeedCV,
            type: "cancelButton",
          },
          {
            label: "Postuler",
            onClick: handleSubmit,
            type: "validateButton",
          }
        ]}
      >
        <div className={classes.modalContent}>
          {deleteCvTemp ? (
            <input type="file" accept="application/pdf" onChange={handleFileUpload} style={{ marginTop: 10 }} />
          ) : state.cv ? (
            <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
              <Typography className={global.subTitle}>{tempCv?.name || state.cvName || "Aucun fichier sélectionné"}</Typography>
              <IconButton onClick={handleDeleteCv} color="secondary">
                <Delete />
              </IconButton>
            </div>
          ) : (
            <input type="file" accept="application/pdf" onChange={handleFileUpload} style={{ marginTop: 10 }} />
          )}

          {tempCv && (
            <FormControlLabel
              control={<Checkbox checked={useAsDefault} onChange={() => setUseAsDefault(!useAsDefault)} />}
              label="Utiliser ce CV par défaut"
            />
          )}
        </div>
      </NewModal>
    </div >
  );
};

const styles = ({ spacing }) => ({
  container: {
    width: '100%',
  },
  btnsContainer: {
    zIndex: 1,
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    '@media only screen and (max-width:1023px)': {
      marginTop: spacing(2),
      width: '100%',
      display: 'flex',

    },
  },
  btnaddfavoris: {
    marginRight: 16,
    '@media only screen and (max-width:1023px)': {
      marginTop: spacing(2),
      marginLeft: 0,
    },
  },
  btnVitrine: {
    color: '#5A6DA1',
    backgroundColor: '#F3F7FF',
    marginRight: 16,
    '@media only screen and (max-width:1023px)': {
      marginLeft: 0,
    },
  },
  nameContainer: {
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(2),
    '@media only screen and (max-width:1023px)': {
      // marginLeft: 0, // Alignement pour écrans étroits
      marginTop: spacing(1),
      width: '100%',
    },
  },
  divInfos: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '@media only screen and (max-width:1023px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: spacing(2), // Ajoute du padding pour améliorer le rendu
      display: 'flex', // Affiche les infos dans la vue étroite
    },
  },
  name: {
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
    fontSize: '1rem',
    '@media only screen and (max-width:1023px)': {
      // color: '#152652', // Change la couleur pour les écrans étroits
      fontSize: '1rem',
    },
  },
  address: {
    marginTop: 5,
    marginBottom: 5,
    fontWeight: 400,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    '@media only screen and (max-width:1023px)': {
      // color: '#152652',
    },
  },
  imgAdress: {
    color: '#FFF',
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media only screen and (max-width:1023px)': {
      marginTop: spacing(2),
      width: '100%',
    },
  },
  titleJob: {
    color: '#FFFFFF',
    fontWeight: 700,
    fontSize: '1.25rem !important',
    '@media only screen and (max-width:1023px)': {
      // color: '#152652',
    },
  },
  modalContent: {
    color: "#152652 !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  candidateButton: {
    marginTop: 20,
    alignSelf: "center",
  }
});


InfoName.propTypes = {
  info: PropTypes.object,
};

export default InfoName;
